var _rect, _path, _path2, _rect2, _path3, _rect3, _path4, _rect4, _path5, _rect5, _path6, _rect6, _path7, _rect7, _path8, _rect8, _path9, _rect9, _path10, _rect10, _path11, _rect11, _path12, _rect12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { SvgIcon } from '@mui/material';
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1500,
    height: 97,
    "data-version": 2,
    "data-id": "lg_pvC7pX1jsm3DhZWYvT",
    viewBox: "0 0 662 97"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006edb",
    d: "M24.41 62.7l-5.523-17.722c-1.842-5.984.69-12.428 6.041-15.593l26.812-15.65c6.617-3.855 15.133-1.439 18.642 5.408l13.752 26.525c4.2 7.883-.46 17.606-9.264 19.275l-35.04 6.962c-6.732 1.323-13.348-2.647-15.42-9.206"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0071e3",
    d: "M133.531 36.107v7.97h-34.05v-7.97zm-22.67 57.86v-65.57q0-5.02 2.36-8.39 2.35-3.36 6.13-5.07 3.78-1.71 7.97-1.71 3.32 0 5.49.55 2.17.54 3.21 1l-2.59 7.98q-.72-.26-1.89-.57-1.16-.31-3.13-.31-4.3 0-6.26 2.19-1.97 2.2-1.97 6.4v63.5z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36.54,
    height: 80.74,
    x: -18.27,
    y: -40.37,
    fill: "none",
    rx: 0,
    ry: 0,
    transform: "translate(118.25 54.1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0071e3",
    d: "M145.851 93.968v-57.86h9.01v8.9h.62q1.6-4.4 5.72-7.06 4.11-2.67 9.29-2.67 1.03 0 2.46.05 1.42.05 2.25.11v9.36q-.41-.1-2.07-.31-1.66-.2-3.52-.2-4.14 0-7.43 1.73-3.28 1.73-5.15 4.76-1.86 3.03-1.86 6.96v36.23z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 29.35,
    height: 58.69,
    x: -14.68,
    y: -29.34,
    fill: "none",
    rx: 0,
    ry: 0,
    transform: "translate(161.03 65.12)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0071e3",
    d: "M208.321 95.218q-8.38 0-14.46-3.73t-9.37-10.4q-3.29-6.68-3.29-15.58 0-8.91 3.21-15.69 3.21-6.78 9.09-10.61 5.87-3.83 13.74-3.83 4.6 0 9.08 1.53t8.13 4.92q3.65 3.39 5.82 8.93 2.17 5.53 2.17 13.56v3.88h-44.92v-7.87h39.9l-4.34 2.9q0-5.69-1.79-10.12-1.79-4.42-5.31-6.93-3.52-2.51-8.74-2.51-5.23 0-8.96 2.56-3.72 2.56-5.69 6.67-1.97 4.12-1.97 8.83v5.23q0 6.41 2.23 10.89 2.22 4.48 6.24 6.78 4.01 2.3 9.29 2.3 3.41 0 6.21-.98 2.79-.98 4.81-2.97 2.02-2 3.11-4.95l9 2.49q-1.34 4.34-4.55 7.66-3.21 3.31-7.95 5.17-4.73 1.87-10.69 1.87"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 51.24,
    height: 59.84,
    x: -25.62,
    y: -29.92,
    fill: "none",
    rx: 0,
    ry: 0,
    transform: "translate(207.32 65.8)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0071e3",
    d: "M265.461 95.218q-5.95 0-10.58-1.74-4.63-1.73-7.63-5.15-3.01-3.41-4.04-8.38l8.85-2.12q1.24 4.76 4.68 6.98 3.45 2.23 8.62 2.23 6.06 0 9.65-2.59 3.6-2.59 3.6-6.16 0-3-2.09-4.99-2.1-2-6.4-2.98l-9.62-2.28q-7.87-1.86-11.7-5.77-3.83-3.91-3.83-10.01 0-4.97 2.79-8.78 2.8-3.8 7.64-5.95 4.84-2.15 11-2.15 5.95 0 10.12 1.79 4.16 1.79 6.78 4.92 2.61 3.13 3.9 7.22l-8.43 2.17q-1.19-3.1-3.96-5.64-2.77-2.54-8.36-2.54-5.18 0-8.62 2.38-3.44 2.38-3.44 6.01 0 3.21 2.33 5.15 2.33 1.94 7.4 3.13l8.75 2.07q7.86 1.86 11.64 5.77 3.78 3.91 3.78 9.86 0 5.07-2.87 9.03-2.87 3.96-8.02 6.24-5.15 2.28-11.94 2.28"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 45.08,
    height: 59.84,
    x: -22.54,
    y: -29.92,
    fill: "none",
    rx: 0,
    ry: 0,
    transform: "translate(266.25 65.8)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0071e3",
    d: "M311.061 59.297v34.67h-9.31v-77.12h9.31v33.29h-1.6q2.64-8.03 7.53-11.39 4.89-3.37 11.46-3.37 5.85 0 10.28 2.41 4.42 2.41 6.88 7.25t2.46 12.19v36.74h-9.37v-35.97q0-6.67-3.49-10.45-3.5-3.78-9.55-3.78-4.14 0-7.45 1.81-3.32 1.81-5.23 5.28-1.92 3.47-1.92 8.44"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 46.32,
    height: 77.12,
    x: -23.16,
    y: -38.56,
    fill: "none",
    rx: 0,
    ry: 0,
    transform: "translate(325.41 55.9)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0071e3",
    d: "M391.291 95.217q-5.49 0-8.85-1.89-3.37-1.89-5.18-4.3-1.81-2.41-2.79-4.01h-1.04v8.95h-9v-77.12h9.31v28.52h.73q.98-1.55 2.74-3.9 1.76-2.36 5.07-4.22 3.31-1.87 8.96-1.87 7.24 0 12.75 3.63 5.52 3.62 8.65 10.32 3.13 6.71 3.13 15.87 0 9.21-3.11 15.94-3.1 6.73-8.61 10.4-5.52 3.68-12.76 3.68m-1.4-8.34q5.44 0 9.08-2.92 3.65-2.93 5.49-7.87 1.84-4.94 1.84-11 0-6-1.81-10.84-1.82-4.84-5.46-7.69-3.65-2.84-9.14-2.84-5.33 0-8.95 2.69-3.63 2.69-5.46 7.48-1.84 4.79-1.84 11.2 0 6.42 1.86 11.34 1.87 4.91 5.51 7.68 3.65 2.77 8.88 2.77"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 51.34,
    height: 78.37,
    x: -25.67,
    y: -39.19,
    fill: "none",
    rx: 0,
    ry: 0,
    transform: "translate(390.6 56.53)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0071e3",
    d: "M448.951 94.698q-5.85 0-10.28-2.41-4.42-2.4-6.88-7.27-2.46-4.87-2.46-12.16v-36.75h9.32v35.97q0 6.68 3.52 10.46 3.52 3.77 9.57 3.77 4.14 0 7.43-1.81t5.2-5.3q1.92-3.5 1.92-8.41v-34.68h9.36v57.86h-9v-14.02h1.24q-2.69 8.12-7.63 11.44-4.95 3.31-11.31 3.31"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 46.32,
    height: 58.59,
    x: -23.16,
    y: -29.3,
    fill: "none",
    rx: 0,
    ry: 0,
    transform: "translate(453 65.9)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0071e3",
    d: "M518.921 36.107v7.97h-34.05v-7.97zm-22.67 57.86v-65.57q0-5.02 2.36-8.39 2.35-3.36 6.13-5.07 3.78-1.71 7.97-1.71 3.31 0 5.49.55 2.17.54 3.21 1l-2.59 7.98q-.73-.26-1.89-.57-1.16-.31-3.13-.31-4.3 0-6.26 2.19-1.97 2.2-1.97 6.4v63.5z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 36.54,
    height: 80.74,
    x: -18.27,
    y: -40.37,
    fill: "none",
    rx: 0,
    ry: 0,
    transform: "translate(503.64 54.1)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0071e3",
    d: "M554.011 36.107v7.97h-34.05v-7.97zm-22.67 57.86v-65.57q0-5.02 2.36-8.39 2.35-3.36 6.13-5.07 3.78-1.71 7.97-1.71 3.32 0 5.49.55 2.17.54 3.21 1l-2.59 7.98q-.72-.26-1.89-.57-1.16-.31-3.13-.31-4.3 0-6.26 2.19-1.97 2.2-1.97 6.4v63.5z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 36.54,
    height: 80.74,
    x: -18.27,
    y: -40.37,
    fill: "none",
    rx: 0,
    ry: 0,
    transform: "translate(538.73 54.1)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#0071e3",
    d: "M587.551 95.218q-8.38 0-14.46-3.73t-9.37-10.4q-3.29-6.68-3.29-15.58 0-8.91 3.21-15.69 3.21-6.78 9.09-10.61 5.87-3.83 13.74-3.83 4.6 0 9.08 1.53t8.13 4.92q3.65 3.39 5.82 8.93 2.17 5.53 2.17 13.56v3.88h-44.92v-7.87h39.9l-4.35 2.9q0-5.69-1.78-10.12-1.79-4.42-5.31-6.93-3.52-2.51-8.74-2.51-5.23 0-8.96 2.56-3.72 2.56-5.69 6.67-1.97 4.12-1.97 8.83v5.23q0 6.41 2.23 10.89 2.22 4.48 6.24 6.78 4.01 2.3 9.29 2.3 3.41 0 6.21-.98 2.79-.98 4.81-2.97 2.02-2 3.11-4.95l9 2.49q-1.34 4.34-4.55 7.66-3.21 3.31-7.95 5.17-4.73 1.87-10.69 1.87"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 51.24,
    height: 59.84,
    x: -25.62,
    y: -29.92,
    fill: "none",
    rx: 0,
    ry: 0,
    transform: "translate(586.55 65.8)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#0071e3",
    d: "M625.031 93.968v-57.86h9v8.9h.62q1.61-4.4 5.72-7.06 4.12-2.67 9.29-2.67 1.04 0 2.46.05 1.43.05 2.25.11v9.36q-.41-.1-2.07-.31-1.65-.2-3.52-.2-4.14 0-7.42 1.73-3.29 1.73-5.15 4.76-1.87 3.03-1.87 6.96v36.23z"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 29.34,
    height: 58.69,
    x: -14.67,
    y: -29.34,
    fill: "none",
    rx: 0,
    ry: 0,
    transform: "translate(640.2 65.12)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M62.18 35.823c-2.15 0-3.948-1.427-4.552-3.38l-1.65.366-.45-1.862 1.918-.426c.259-2.398 2.266-4.273 4.735-4.273a4.787 4.787 0 010 9.575m0-7.66a2.873 2.873 0 100 5.746 2.873 2.873 0 000-5.745m1.916 26.81a8.617 8.617 0 01-17.235 0 8.588 8.588 0 012.503-6.07l-2.672-2.991 1.405-1.301 2.765 3.094a8.57 8.57 0 014.617-1.35 8.616 8.616 0 018.617 8.618m-8.617-6.703a6.702 6.702 0 100 13.405 6.702 6.702 0 000-13.405m-5.84-16.014l4.02-.893.45 1.862-4.021.893zm-4.692 3.567a6.653 6.653 0 01-1.246 3.87l3.12 3.49-1.405 1.303-3.05-3.414c-1.14.897-2.56 1.454-4.122 1.454a6.702 6.702 0 110-13.405c2.845 0 5.261 1.78 6.234 4.282l3.29-.731.45 1.862-3.328.739c.016.184.057.361.057.55m-6.703-4.801a4.802 4.802 0 100 9.603 4.802 4.802 0 000-9.603"
  }))));
};
export default SvgLogo;